<template>
  <div
    class="absolute h-[inherit] w-screen flex justify-end z-10 pointer-events-none"
  >
    <transition appear>
      <div
        v-if="state.cartOpened"
        class="rounded-l shadow-md bg-white w-screen max-w-sm overflow-auto pointer-events-auto"
      >
        <div class="flex justify-end pt-2 pr-2 sticky top-0 z-20">
          <StellaButton
            icon="x"
            size="sm"
            type="ghost-secondary"
            @click="state.cartOpened = false"
          />
        </div>
        <GlobalCart class="px-4" :options="['cart', 'forlater']" />
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
import { useAppSidePanelState } from './appSidePanelState'

const GlobalCart = defineAsyncComponent(
  () => import('../common/globalCart/GlobalCart.vue'),
)

const state = useAppSidePanelState()
</script>
